// @generated by protoc-gen-es v2.11.0 with parameter "target=ts+js"
// @generated from file lease/common/v1/types.proto (package lease.common.v1, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file lease/common/v1/types.proto.
 */
export const file_lease_common_v1_types = /*@__PURE__*/
  fileDesc("ChtsZWFzZS9jb21tb24vdjEvdHlwZXMucHJvdG8SD2xlYXNlLmNvbW1vbi52MSqIAQoKQXV0aE1ldGhvZBIbChdBVVRIX01FVEhPRF9VTlNQRUNJRklFRBAAEhoKFkFVVEhfTUVUSE9EX01PQklMRV9QSU4QARIhCh1BVVRIX01FVEhPRF9WRU5VRV9BQ0NFU1NfQ09ERRACEh4KGkFVVEhfTUVUSE9EX01PQklMRV9FWFBSRVNTEANCPVo7Z2l0aHViLmNvbS92ZW5kaW5nb250cmFjay9hcGkvZ28tZ2VuL2xlYXNlL2NvbW1vbi92MTtjb21tb25iBnByb3RvMw");

/**
 * Describes the enum lease.common.v1.AuthMethod.
 */
export const AuthMethodSchema = /*@__PURE__*/
  enumDesc(file_lease_common_v1_types, 0);

/**
 * BREAKING CHANGE JUSTIFICATION (SD-3017):
 * AuthMethod enum was moved from lease.kiosk.v1 to lease.common.v1 to fix architectural issues:
 * 1. Eliminates cross-references between sibling packages (kiosk and merchant)
 * 2. Follows protobuf best practices for shared types
 * 3. No functional changes - enum values remain identical
 * 4. Required for proper implementation of auth method tracking across services
 *
 * Migration impact: Import paths need to be updated in implementing services
 * AuthMethod represents an available authentication method for customers
 *
 * @generated from enum lease.common.v1.AuthMethod
 */
export const AuthMethod = /*@__PURE__*/
  tsEnum(AuthMethodSchema);

